import { render, staticRenderFns } from "./VueQueryDevtoolsPanel.vue?vue&type=template&id=08c9ea6c"
import script from "./VueQueryDevtoolsPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./VueQueryDevtoolsPanel.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.22_css-loader@6.7.4_webpack@5.102.1__ejs@3.1.1_8e3b2d983739573c8a37493d5fe535f8/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports